export default __webpack_public_path__ + "static/media/place-3.b8be6aa2.jpg";